import { defineAction } from 'redux-define';
import { TheApp, LOADING, ERROR, SUCCESS, FILTER } from '../../constants/stateConstants';

export const items = defineAction('items', [LOADING, ERROR, SUCCESS], TheApp);
export const LIST = defineAction('LIST', [ FILTER, LOADING, ERROR, SUCCESS], items);
export const GET = defineAction('GET', [ LOADING, ERROR, SUCCESS], items);
export const CREATE = defineAction('CREATE', [ LOADING, ERROR, SUCCESS], items);
export const UPDATE = defineAction('UPDATE', [ LOADING, ERROR, SUCCESS], items);
export const DELETE = defineAction('DELETE', [ LOADING, ERROR, SUCCESS], items);